<script setup>

import {computed} from "vue";

const props = defineProps({
  difficulty: {
    type: [Number, null],
    required: true,
  },
  tiers: {
    type: Object,
    default() {
      return {
        low: 39,
        med: 54,
        high: 74,
        vHigh: 100,
      }
    },
    validator(value) {
      return ['low', 'med', 'high',].every(prop => Object.keys(value).includes(prop));
    }
  },
})

const color = computed(() => {
  const {difficulty} = props;
  if (difficulty === null) return 'grey';
  if (difficulty <= props.tiers.low) return 'everest-bright';
  if (difficulty <= props.tiers.med) return 'purple';
  if (difficulty <= props.tiers.high) return 'pink';
  return 'denali';
})

const name = computed(() => {
  const {difficulty} = props;
  if (difficulty === null) return 'Fetching data';
  if (difficulty <= props.tiers.low) return 'Low';
  if (difficulty <= props.tiers.med) return 'Medium';
  if (difficulty <= props.tiers.high) return 'High';
  return 'Very High';
});
</script>

<template>
  <span
    :class="[
      'tw-text-base tw-font-bold tw-inline-flex tw-items-center tw-h-8 tw-px-4 tw-rounded-[7.5px] tw-text-white',
      `tw-bg-${color}`,
    ]"
  >
    {{ name }}
    <i
      v-if="difficulty == null"
      class="fas fa-spinner fa-spin tw-ml-1"
    />
  </span>
</template>
